function init_selects() {

    //Custom selects selector
    var $selects = $('select.form-select:not(.no-touchy):not(.creatable):not(.scaler)');
    var $creatable = $('select.form-select.creatable:not(.no-touchy)');
    var $scaler = $('select.form-select.scaler:not(.no-touchy)');
    var $tags = $('select.tag-select');

    //Dropup class
    //TODO: Look at @Taeon's code for conditionally adding this? Rather than forced?
    //NB: IMPORTANT to do this on :ready to fix the issue with the shifting dropup when opened
    //    The issue was the search box sitting below the dropdown (but offscreen)
    $('select').on('chosen:ready', function(e){
        var $container = $(e.target).next('.chosen-container');

        if($(this).hasClass('drop-up')) {
            $container.addClass('drop-up');
        }
    });

    //Initialise custom select inputs
    $selects.chosen({
        width: '100%',
        disable_search_threshold: 10,
        search_contains: true,
        persistent_create_option: false,
        no_results_text: lang['chosen_no_results_text'],
        placeholder_text_single: lang['chosen_placeholder_text_single'],
        placeholder_text_multiple: lang['chosen_placeholder_text_multiple']
    });

    //Initialise creatable selects
    $creatable.chosen({
        width: '100%',
        disable_search_threshold: 10,
        search_contains: true,
        create_option: function(name) {
            var chosen = this;
            var $field = $(this.form_field);
            var context = $field.data('context');
            var value1 = $field.data('value1');

            if(context) {
                $field.attr('disabled', 'disabled').trigger('chosen:updated');

                var data = {
                    name: name,
                    value1: value1
                };

                if(context === 'suppliers') {
                    data.supplier_name = data.name;
                }

                if(context === 'categories') {
                    data.category_name = data.name;
                }

                ajax_call('post', '/admin/' + context + '/add', data, function(resp) {
                    if(resp.response) {
                        chosen.append_option({
                            value: resp.body.id,
                            text: resp.body.name
                        });
                    } else {
                        alert(lang['unable_to_add_' + context]);
                    }

                    $field.removeAttr('disabled').trigger('chosen:updated');
                });
            } else {
                alert(lang['unable_to_add_item']);
            }

        },
        persistent_create_option: true,
        skip_no_results: true,
        create_option_text: '',
        no_results_text: lang['chosen_no_results_text'],
        placeholder_text_single: lang['chosen_placeholder_text_single'],
        placeholder_text_multiple: lang['chosen_placeholder_text_multiple']
    });

    //Initialise creatable selects
    $scaler.chosen({
        width: "125px",
        disable_search_threshold: 10,
        search_contains: true,
        create_option: function(num) {
            var parsed = parseFloat(num);

            if(isNaN(parsed)) {
                alert(lang['unable_to_add_item']);
            } else {
                this.append_option({
                    value: parsed,
                    text: parsed + "x " + lang['scale']
                });
            }
        },
        persistent_create_option: true,
        skip_no_results: true,
        create_option_text: '',
        no_results_text: lang['chosen_no_results_text'],
        placeholder_text_single: lang['chosen_placeholder_text_single']
    });

    $scaler.on('change', function(e) {
        scale_values(e.target.value);
    })

    //Initialise custom select inputs
    $tags.chosen({
        width: '100%',
        disable_search_threshold: 10,
        search_contains: true,
        create_option: function(name) {
            var chosen = this;
            var $field = $(this.form_field);

            $field.attr('disabled', 'disabled').trigger('chosen:updated');

            ajax_call('post', '/admin/tags/add', {name: name}, function(resp) {
                if(resp.response) {
                    chosen.append_option({
                        value: resp.body.id,
                        text: resp.body.name
                    });

                } else {
                    alert(lang['unable_to_add_tag']);
                }

                $field.removeAttr('disabled').trigger('chosen:updated').trigger('chosen:open');
            });

        },
        persistent_create_option: true,
        skip_no_results: true,
        display_selected_options: false,
        hide_results_on_select: false,
        create_option_text: '',
        no_results_text: lang['chosen_no_tags_text'],
        placeholder_text_single: lang['chosen_placeholder_text_single'],
        placeholder_text_multiple: lang['chosen_placeholder_text_multiple']
    });

}

$(function() {
    //Initialise custom select inputs
    init_selects();
});
